export const WriteRight = "WEB_MODULE_PILOT_COASTAL_SEGMENTS_WRITE";
export const Rights = [
    WriteRight
]
